import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-sign-in',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './sign-in.component.html',
    styleUrl: './sign-in.component.scss',
})
export class SignInComponent implements OnInit {
    credentials = { email: '', password: '' };
    isLoading = false;
    errorMessage = '';
    isCheckingAuth = true;
    showPassword: boolean = false;

    constructor(private authService: AuthService, private router: Router) {}

    ngOnInit(): void {
        const token = localStorage.getItem('a_id');
        const user = this.authService.getCurrentUser();

        // Jika token & user valid → langsung arahkan RoleGuard
        if (token && user) {
            this.router.navigate(['/redirect'], { replaceUrl: true });
            return;
        }

        // Kalau tidak valid
        localStorage.removeItem('a_id');
        localStorage.removeItem('user');
        this.isCheckingAuth = false;
    }

    showServiceSelection = false;
    availableServices: any[] = [];

    async onSignIn(): Promise<void> {
        this.errorMessage = '';

        if (
            !this.credentials.email.trim() ||
            !this.credentials.password.trim()
        ) {
            this.errorMessage = 'Please enter both email and password';
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.credentials.email)) {
            this.errorMessage = 'Please enter a valid email address';
            return;
        }

        this.isLoading = true;

        try {
            const result = await this.authService.signIn(this.credentials);

            if (result && result.success) {
                // Check if user has multiple services
                if (result.services && result.services.length > 1) {
                    this.availableServices = result.services;
                    this.showServiceSelection = true;
                    this.isLoading = false; // Stop loading, wait for selection
                    return; 
                }

                this.isCheckingAuth = false;
                // Single service or none -> auto redirect
                this.router.navigate(['/redirect'], { replaceUrl: true });
            } else {
                this.errorMessage = 'Invalid email or password';
            }
        } catch (error: any) {
            this.errorMessage =
                error.message || 'An error occurred during login.';
        } finally {
            if (!this.showServiceSelection) {
                 this.isLoading = false;
            }
        }
    }

    selectService(service: any) {
        // Validation for implemented services
        const implementedServices = ['parking', 'ticketing'];

        if (!implementedServices.includes(service.code)) {
            Swal.fire({
                title: 'Mohon Maaf',
                text: 'Fitur ini masih dalam tahap pengembangan.',
                icon: 'info',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK'
            });
            return;
        }

        console.log('SignInComponent: selectService called', service);
        this.authService.updateServiceType(service.code);
        console.log('SignInComponent: navigating to /redirect');
        this.router.navigate(['/redirect'], { replaceUrl: true }).then(success => {
            console.log('SignInComponent: Navigation result:', success);
        });
    }
}
